import React from 'react';
import { Button } from './ui/button';

const TouchButton = ({ 
  children, 
  size = 'default',
  className = '',
  touchOptimized = true,
  ...props 
}) => {
  const touchSizes = {
    sm: touchOptimized ? 'min-h-[44px] px-4 py-2 text-sm' : '',
    default: touchOptimized ? 'min-h-[44px] px-6 py-3' : '',
    lg: touchOptimized ? 'min-h-[48px] px-8 py-4 text-lg' : '',
    icon: touchOptimized ? 'min-h-[44px] min-w-[44px] p-2' : ''
  };

  const touchClasses = `
    ${touchSizes[size]}
    ${touchOptimized ? 'touch-manipulation' : ''}
    ${className}
  `.trim();

  return (
    <Button 
      size={touchOptimized ? undefined : size}
      className={touchClasses}
      {...props}
    >
      {children}
    </Button>
  );
};

export default TouchButton;